"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gameManager = exports.game = exports.KHGameManager = exports.Z20Game = exports.Controls = void 0;
const KHInputKeyCompeting_1 = require("./KH/Input/Key/KHInputKeyCompeting");
const KHInputKeyRepeating_1 = require("./KH/Input/Key/KHInputKeyRepeating");
const KHController_1 = require("./KH/Input/KHController");
const KHInputProviderController_1 = require("./KH/Input/KHInputProviderController");
const KHInputScene_1 = require("./KH/Input/KHInputScene");
const KHInputSet_1 = require("./KH/Input/KHInputSet");
const KHUnifiedInput_1 = require("./KH/Input/KHUnifiedInput");
const KHAchievements_1 = require("./KH/KHAchievements");
const KHAudioMixer_1 = require("./KH/KHAudioMixer");
const KHGame_1 = require("./KH/KHGame");
const KHHighScores_1 = require("./KH/KHHighScores");
const KHPersistentReference_1 = require("./KH/References/KHPersistentReference");
const ninepatch_plugin_js_1 = require("phaser3-rex-plugins/plugins/ninepatch-plugin.js");
const TSGameNormal_1 = require("./TSGameNormal");
const Z20GameScene_1 = require("./Z20GameScene");
const Z20PreloadScene_1 = require("./Z20PreloadScene");
const KHInputKeyFromAxis_1 = require("./KH/Input/Key/KHInputKeyFromAxis");
const Z20RuleDisplayScene_1 = require("./Z20RuleDisplayScene");
const KHInputKeyResettable_1 = require("./KH/Input/Key/KHInputKeyResettable");
const IGO50GameListScene_1 = require("./IGO50GameListScene");
const Z20AudioScene_1 = require("./Z20AudioScene");
const IGO50PauseScene_1 = require("./IGO50PauseScene");
const Z20MenuScene_1 = require("./Z20MenuScene");
const Z20SeedPickerScene_1 = require("./Z20SeedPickerScene");
const Z20CutScene_1 = require("./Z20CutScene");
const config = {
    type: Phaser.AUTO,
    scale: {
        width: 384,
        height: 216,
        // Commented out because it makes it stretch at start
        // mode: Phaser.Scale.FIT,
        // Commented out because it interacts poorly with index.html rules
        // autoCenter: Phaser.Scale.CENTER_HORIZONTALLY
    },
    input: {
        gamepad: true,
    },
    plugins: {
        global: [{
                key: 'rexNinePatchPlugin',
                plugin: ninepatch_plugin_js_1.default,
                start: true
            }]
    },
    parent: "phaser-game",
    version: "1.0.0",
    pixelArt: true,
    scene: [Z20PreloadScene_1.Z20PreloadScene, Z20MenuScene_1.default, Z20GameScene_1.Z20GameScene, Z20RuleDisplayScene_1.Z20RuleDisplayScene, Z20CutScene_1.default, IGO50GameListScene_1.IGO50GameListScene, IGO50PauseScene_1.IGO50PauseScene, KHInputScene_1.KHInputScene, Z20AudioScene_1.Z20AudioScene, Z20SeedPickerScene_1.Z20SeedPickerScene]
};
var Controls;
(function (Controls) {
    Controls[Controls["Up"] = 0] = "Up";
    Controls[Controls["Down"] = 1] = "Down";
    Controls[Controls["Left"] = 2] = "Left";
    Controls[Controls["Right"] = 3] = "Right";
    Controls[Controls["Confirm"] = 4] = "Confirm";
    Controls[Controls["Start"] = 5] = "Start";
})(Controls || (exports.Controls = Controls = {}));
class Z20Game extends KHGame_1.KHGame {
    constructor(config, khConfig) {
        super(config, khConfig);
        this.npcCount = 15;
        this.toolCount = 10;
        this.grassCount = 4;
        this.musicMute = new KHPersistentReference_1.KHPersistentReference(false, true);
        this.sfxMute = new KHPersistentReference_1.KHPersistentReference(false, true);
        this.currentStreak = new KHPersistentReference_1.KHPersistentReference(0, true);
        this.bestStreak = new KHPersistentReference_1.KHPersistentReference(0, true);
        this.attempts = new KHPersistentReference_1.KHPersistentReference(0, true);
        this.totalTime = new KHPersistentReference_1.KHPersistentReference(0, true);
        this.wins = new KHPersistentReference_1.KHPersistentReference(0, true);
        this.inProgress = new KHPersistentReference_1.KHPersistentReference(false, true);
        this.mixers = { sfx: new KHAudioMixer_1.KHAudioMixer() };
        this.achievements = new KHAchievements_1.default();
        this.highScores = new KHHighScores_1.default((a, b) => KHHighScores_1.default.NumberAscendingComparator(a.time, b.time), 5, []);
        this.storageManager.registerAll({
            [KHAchievements_1.default.MENAGERIE_KEY]: this.achievements,
            'kh.forestwernat.options': {
                'mute_music': this.musicMute,
                'mute_sfx': this.sfxMute,
            },
            'kh.forestwernat.save': {
                'best_streak': this.bestStreak,
                'current_streak': this.currentStreak,
                'in_progress': this.inProgress,
                'attempts': this.attempts,
                'wins': this.wins,
                'total_time': this.totalTime,
            },
            'kh.forestwernat.highscores': this.highScores,
        });
        if (this.inProgress.get()) {
            this.currentStreak.set(0);
            this.inProgress.set(false);
        }
    }
}
exports.Z20Game = Z20Game;
class KHGameManager {
    constructor(game) {
        this.game = game;
    }
    addOrGetAudioScene(scene) {
        if (this._audio == null) {
            scene.scene.run(Z20AudioScene_1.Z20AudioScene.NAME);
            this._audio = scene.scene.get(Z20AudioScene_1.Z20AudioScene.NAME);
        }
        return this._audio;
    }
    addOrGetInputScene(scene) {
        if (this._inputScene == null) {
            scene.scene.run(KHInputScene_1.KHInputScene.NAME);
            this._inputScene = scene.scene.get(KHInputScene_1.KHInputScene.NAME);
        }
        return this._inputScene;
    }
    getController() {
        if (this._controller != null)
            return this._controller;
        const inputSet = new KHInputSet_1.KHInputSet("controller");
        const inputMap = new Map();
        const axisThreshold = 0.5;
        const das = 200;
        const arr = 100;
        const left = KHUnifiedInput_1.KHUnifiedInput.FromConfig({
            inputSet,
            keys: [Phaser.Input.Keyboard.KeyCodes.LEFT, Phaser.Input.Keyboard.KeyCodes.A],
            buttons: [KHInputProviderController_1.KHPadInput.Left],
            otherInputs: [new KHInputKeyFromAxis_1.KHInputKeyKeyFromAxis(inputSet, KHUnifiedInput_1.KHUnifiedInput.GetCombinedAxis(inputSet, KHUnifiedInput_1.KHUnifiedInput.GetControllerAxesScaledAxial(inputSet, KHInputProviderController_1.KHPadAxis.LeftStickX, 0)), -axisThreshold)]
        });
        const right = KHUnifiedInput_1.KHUnifiedInput.FromConfig({
            inputSet,
            keys: [Phaser.Input.Keyboard.KeyCodes.RIGHT, Phaser.Input.Keyboard.KeyCodes.D],
            buttons: [KHInputProviderController_1.KHPadInput.Right],
            otherInputs: [new KHInputKeyFromAxis_1.KHInputKeyKeyFromAxis(inputSet, KHUnifiedInput_1.KHUnifiedInput.GetCombinedAxis(inputSet, KHUnifiedInput_1.KHUnifiedInput.GetControllerAxesScaledAxial(inputSet, KHInputProviderController_1.KHPadAxis.LeftStickX, 0)), axisThreshold)]
        });
        const competingLeft = new KHInputKeyRepeating_1.KHInputKeyRepeating(inputSet, new KHInputKeyCompeting_1.KHInputKeyCompeting(inputSet, left, right, false), das, arr);
        const competingRight = new KHInputKeyRepeating_1.KHInputKeyRepeating(inputSet, new KHInputKeyCompeting_1.KHInputKeyCompeting(inputSet, right, left, true), das, arr);
        const up = KHUnifiedInput_1.KHUnifiedInput.FromConfig({
            inputSet,
            keys: [Phaser.Input.Keyboard.KeyCodes.UP, Phaser.Input.Keyboard.KeyCodes.W],
            buttons: [KHInputProviderController_1.KHPadInput.Up],
            otherInputs: [new KHInputKeyFromAxis_1.KHInputKeyKeyFromAxis(inputSet, KHUnifiedInput_1.KHUnifiedInput.GetCombinedAxis(inputSet, KHUnifiedInput_1.KHUnifiedInput.GetControllerAxesScaledAxial(inputSet, KHInputProviderController_1.KHPadAxis.LeftStickY, 0)), -axisThreshold)]
        });
        const down = KHUnifiedInput_1.KHUnifiedInput.FromConfig({
            inputSet,
            keys: [Phaser.Input.Keyboard.KeyCodes.DOWN, Phaser.Input.Keyboard.KeyCodes.S],
            buttons: [KHInputProviderController_1.KHPadInput.Down],
            otherInputs: [new KHInputKeyFromAxis_1.KHInputKeyKeyFromAxis(inputSet, KHUnifiedInput_1.KHUnifiedInput.GetCombinedAxis(inputSet, KHUnifiedInput_1.KHUnifiedInput.GetControllerAxesScaledAxial(inputSet, KHInputProviderController_1.KHPadAxis.LeftStickY, 0)), axisThreshold)]
        });
        const competingUp = new KHInputKeyRepeating_1.KHInputKeyRepeating(inputSet, new KHInputKeyCompeting_1.KHInputKeyCompeting(inputSet, up, down, false), das, arr);
        const competingDown = new KHInputKeyRepeating_1.KHInputKeyRepeating(inputSet, new KHInputKeyCompeting_1.KHInputKeyCompeting(inputSet, down, up, true), das, arr);
        inputMap.set(Controls.Left, competingLeft);
        inputMap.set(Controls.Right, competingRight);
        inputMap.set(Controls.Up, competingUp);
        inputMap.set(Controls.Down, competingDown);
        inputMap.set(Controls.Confirm, new KHInputKeyResettable_1.KHInputKeyResettable(inputSet, KHUnifiedInput_1.KHUnifiedInput.FromConfig({
            inputSet,
            keys: [Phaser.Input.Keyboard.KeyCodes.ENTER, Phaser.Input.Keyboard.KeyCodes.SPACE, Phaser.Input.Keyboard.KeyCodes.Z],
            buttons: [KHInputProviderController_1.KHPadInput.A],
            // mouseInputs: [KHMouseInput.Left],
        })));
        inputMap.set(Controls.Start, KHUnifiedInput_1.KHUnifiedInput.FromConfig({
            inputSet,
            keys: [Phaser.Input.Keyboard.KeyCodes.P],
            buttons: [KHInputProviderController_1.KHPadInput.Start]
        }));
        this._controller = new KHController_1.KHGenericController(inputMap, new Map(), inputSet);
        return this._controller;
    }
    getGames() {
        if (this._games === undefined) {
            this._games = [
                () => new TSGameNormal_1.TSGameRandomViz(),
                () => new TSGameNormal_1.TSGameRandomViz(),
                () => new TSGameNormal_1.TSGameRandomViz(),
            ];
        }
        return this._games;
    }
}
exports.KHGameManager = KHGameManager;
exports.game = new Z20Game(config, { scaleMode: KHGame_1.KHScaleMode.ScalePixelPerfect, alwaysMaxScale: true });
exports.gameManager = new KHGameManager(exports.game);
